import { render, staticRenderFns } from "./ConfirmPasswordDialog.vue?vue&type=template&id=c0745500&scoped=true"
import script from "./ConfirmPasswordDialog.vue?vue&type=script&lang=ts"
export * from "./ConfirmPasswordDialog.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmPasswordDialog.vue?vue&type=style&index=0&id=c0745500&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0745500",
  null
  
)

export default component.exports